import { useState } from 'react';

export default function MediaSection() {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const galleryImages = [
    '/space-open.png',
    '/space-private.png',
    '/space-innovation.png',
    '/space-relaxation.png',
    '/space-cafe.png',
    '/space-studio.png',
    '/space-events.png',
    '/hero-space.png',
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            معرض الوسائط
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            شاهد مساحاتنا وفعالياتنا ومجتمعنا في العمل
          </p>
        </div>

        {/* Video Section */}
        <div className="mb-16">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl group cursor-pointer" onClick={() => setShowVideoModal(true)}>
            <img
              src="/hero-space.png"
              alt="معاينة الفيديو"
              className="w-full h-[500px] object-cover object-center"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&h=600&fit=crop&q=80';
              }}
            />
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-all duration-300 flex items-center justify-center">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className="ri-play-fill text-[#FF6B6B] text-4xl mr-1"></i>
              </div>
            </div>
            <div className="absolute bottom-8 right-8 left-8">
              <h3 className="font-bold text-2xl text-white mb-2">
                جولة في مساحة شباب
              </h3>
              <p className="text-white/90">
                اكتشف مساحاتنا وتعرف على مجتمعنا
              </p>
            </div>
          </div>
        </div>

        {/* Image Gallery */}
        <div>
          <h3 className="font-bold text-2xl text-gray-900 mb-8 text-center">
            معرض الصور
          </h3>
          <div className="relative">
            {/* Gradient Overlays */}
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none"></div>
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none"></div>
            
            <div className="overflow-x-auto pb-4" dir="ltr">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                {galleryImages.map((image, index) => (
                  <div
                    key={index}
                    className="relative w-80 h-60 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex-shrink-0"
                  >
                    <img
                      src={image}
                      alt={`صورة المعرض ${index + 1}`}
                      className="w-full h-full object-cover object-center hover:scale-110 transition-transform duration-500"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = `https://via.placeholder.com/400x300/FF6B6B/FFFFFF?text=Gallery+${index + 1}`;
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideoModal && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setShowVideoModal(false)}
        >
          <div className="relative w-full max-w-4xl">
            <button
              onClick={() => setShowVideoModal(false)}
              className="absolute -top-12 left-4 text-white hover:text-[#FF6B6B] transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-4xl"></i>
            </button>
            <div className="bg-gray-900 rounded-2xl overflow-hidden aspect-video">
              <div className="w-full h-full flex items-center justify-center text-white">
                <div className="text-center">
                  <i className="ri-video-line text-6xl mb-4 text-[#FF6B6B]"></i>
                  <p className="text-xl">عنصر نائب للفيديو</p>
                  <p className="text-gray-400 mt-2">أدخل رابط الفيديو الخاص بك هنا</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
